import { memo, useState } from "react";

import CfdFavoriteModal from "./CfdFavouriteModal";
import CfdFooterSection from "./cfdFooter/CfdFooterSection";
import CfdDetailsSection from "./cfdDetails/CfdDetailsSection";
import CfdImageSection from "../cfdImage/CfdImageSection";
import { trackButtonClick } from "@/utils/analytics";
import { navigateToProperty } from "@/utils/propertyNavigation";

const CfdCardItem = ({
  item,
  activeTab,
  onRefresh,
  showTags = false,
  isGridOrList = false,
  isModalOpen = false,
}) => {
  const isSavedTab = activeTab === "saved";
  const onWatchList = isSavedTab ? "Y" : item?.onWatchList === "Y";

  const [isPropertySaved, setIsPropertySaved] = useState(onWatchList);
  const [showModal, setShowModal] = useState(false);

  const handleNavigatePDP = () => {
    const propertyId = isSavedTab
      ? item?.propertyDetails?.propertyId
      : item?.propertyId;
    const category = item?.propertyDetails?.commonAttributes?.propCategory || item?.propertyCategory;
    const propertyStatus = item?.propertyDetails?.commonAttributes?.status || item?.propertyStatus;
    const listingUrl = item?.propertyListingDetails?.listingUrl || item?.listingUrl;
    const listingId = item?.propertyListingDetails?.listingId || item?.listingId;

    trackButtonClick({
      eventName: "cfd_property_details_card_click",
      eventParams: { active_tab: activeTab },
      eventCategory: "CFD",
      eventSource: "on cfd property card click",
      eventLabel: `Property Id: ${propertyId}`,
    });
    navigateToProperty(`/property/${propertyId}`, category, propertyStatus);
  };

  const hasValidCountdown =
    item?.listingType === "AUCN" &&
    (item?.propertyStatus === "ACTV" || item?.propertyStatus === "ACTIVE") &&
    typeof item?.auctionTimeLeft === "number"
      ? true
      : false;

  return (
    <div
      className={`cfd-card-container ${
        isModalOpen ? "cfd-card-modal-wrapper" : "cfd-card-wrapper"
      }`}
    >
      {/* Section 1 - Image */}
      <CfdImageSection
        item={item}
        showTags={showTags}
        isGridOrList={isGridOrList}
        onNavigatePDP={handleNavigatePDP}
        isPropertySaved={isPropertySaved}
        setIsPropertySaved={setIsPropertySaved}
        setShowModal={setShowModal}
        activeTab={activeTab}
        isModalOpen={isModalOpen}
      />

      {!isModalOpen && (
        <CfdFavoriteModal
          showModal={showModal}
          handleClose={() => setShowModal(false)}
        />
      )}

      {/* Section 2 - Details */}
      <CfdDetailsSection
        item={item}
        onNavigatePDP={handleNavigatePDP}
        hasValidCountdown={hasValidCountdown}
        activeTab={activeTab}
        isModalOpen={isModalOpen}
      />

      {/* Section - 3 - Price and Buttons */}
      {!isModalOpen && (
        <CfdFooterSection
          item={item}
          onRefresh={onRefresh}
          activeTab={activeTab}
          isModalOpen={isModalOpen}
          onNavigatePDP={handleNavigatePDP}
          isPropertySaved={isPropertySaved}
          setIsPropertySaved={setIsPropertySaved}
          setShowModal={setShowModal}
        />
      )}
    </div>
  );
};

export default memo(CfdCardItem);
